gsap.from(".gsap_ani1", {
  opacity:0,
  duration: 2,
    scrollTrigger: {
    trigger: ".gsap_ani1",
    scroller: "body",
    // markers: true,
    start: "top 90%",
      end:"top 80%",
    scrub: 1, // crub value can be boolean and also can be from 1 to 5

  },
  y: 100,
  scrub: true,
});

gsap.from(".gsap_ani2", {
  opacity:0,
  duration: 2,
    scrollTrigger: {
    trigger: ".gsap_ani2",
    scroller: "body",
    // markers: true,
    start: "top 85%",
      end:"top 75%",
    scrub: 1, // crub value can be boolean and also can be from 1 to 5

  },
  x:-50,
  stagger:0.5,
  scrub: true,
});
gsap.from(".gsap_ani3", {
  opacity:0,
  duration: 2,
    scrollTrigger: {
    trigger: ".gsap_ani3",
    scroller: "body",
    // markers: true,
    start: "top 75%",
      end:"top 65%",
    scrub: 1, // crub value can be boolean and also can be from 1 to 5

  },
  x:50,
  stagger:0.5,
  scrub: true,
});
gsap.from(".pnb_home_botm_icon_div", {
  opacity:0,
  duration: 2,
    scrollTrigger: {
    trigger: ".pnb_home_botm_icon_div",
    scroller: "body",
    // markers: true,
    start: "top 75%",
      end:"top 65%",
    scrub: 1, // crub value can be boolean and also can be from 1 to 5

  },
  x:50,
  stagger:0.5,
  scrub: true,
});
gsap.from(".gsap_ani_sldr", {
  opacity:0,
  duration: 2,
    scrollTrigger: {
    trigger: ".gsap_ani_sldr",
    scroller: "body",
    // markers: true,
    start: "top 90%",
      end:"top 80%",
    scrub: 1, // crub value can be boolean and also can be from 1 to 5

  },
  y: 100,
  scrub: true,
});